import React from "react";
import { PythonService } from "../../api/python";
import ExcelUploadPanel from "./ExcelUploadPanel";

const ZOOM_HELP = `Formato del Excel:
- Fila 1: encabezados (ej. usuario | contraseña nueva)
- Fila 2 en adelante: email en col. A, contraseña en col. B`;

const ZoomPasswords = () => (
  <ExcelUploadPanel
    title="Actualización de contraseñas Zoom"
    description="Sube un Excel con emails y contraseñas nuevas. Las contraseñas se codifican en el servidor."
    helpText={ZOOM_HELP}
    submitLabel="Actualizar contraseñas"
    onSubmit={(file) => PythonService.updateZoomPasswords(file)}
  />
);

export default ZoomPasswords;
